import React, { useEffect, useRef } from 'react'
import QRCode from 'qrcode'

const QRCodeGenerator = ({ width, height, url }) => {
  const canvasRef = useRef(null)

  useEffect(() => {
    if (canvasRef.current) {
      QRCode.toCanvas(
        canvasRef.current,
        url,
        {
          color: {
            dark: '#000000',
            light: '#0000',
          },
          width,
          height,
          margin: 2,
          errorCorrectionLevel: 'H',
        },
        (error) => {
          if (error) console.error(error)
        }
      )
    }
  }, [url])

  return (
    <div style={{ textAlign: 'center' }}>
      <canvas ref={canvasRef} />
    </div>
  )
}

export default QRCodeGenerator
